import { BackgammonImageCollectionKeys } from '@backgammon/constants/imageCollection';
import Color from '@base/features/game/model/color';
import Drawable from '@base/features/game/model/drawable';
import ImageProvider from '@base/features/image/imageProvider';

export default class DoubleCubeView extends Drawable {
  enabled = false;
  value = 0;
  text: string;
  color?: Color;

  constructor(
    private imageProvider: ImageProvider<BackgammonImageCollectionKeys>,
    context: CanvasRenderingContext2D
  ) {
    super(context);
    this.setValue(64);
    this.setColor(undefined);
    this.text = '';
  }

  render(context: CanvasRenderingContext2D) {
    super.render(context);
    this.renderValue(context);
  }

  renderValue(context: CanvasRenderingContext2D) {
    const CANVAS_TEXT_SIZE_BREAKPOINT = 1200;
    const fontSize = context.canvas.width > CANVAS_TEXT_SIZE_BREAKPOINT ? 24 : 14;
    context.textBaseline = 'middle';
    context.font = `bold ${fontSize}px SF Pro Display`;
    context.textBaseline = 'middle';
    context.fillStyle = 'white';
    const textSize = context.measureText(this.text);
    context.fillText(this.text, this.position.x - textSize.width / 2, this.position.y);
  }

  setColor(color?: Color) {
    this.color = color;
    this.updateColor();
  }

  setValue(value: number) {
    this.value = value;
    this.updateValue();
  }

  updateColor() {
    if (!this.color) {
      this.setValue(64);
      this.image = this.imageProvider.get('DoubleCubeGray');
    } else if (this.color === Color.Black) {
      this.image = this.imageProvider.get('DoubleCubeBlack');
    } else if (this.color === Color.White) {
      this.image = this.imageProvider.get('DoubleCubeWhite');
    }
  }

  setActive() {
    switch (this.color) {
      case Color.Black:
        this.image = this.imageProvider.get('DoubleCubeBlackActive');
        break;
      case Color.White:
        this.image = this.imageProvider.get('DoubleCubeWhiteActive');
        break;
      default:
        this.image = this.imageProvider.get('DoubleCubeGrayActive');
    }
  }

  updateValue() {
    this.text = this.value.toString();
  }
}
